"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemClient = void 0;
const service_client_lib_1 = require("@manifoldxyz/service-client-lib");
/**
 * Client for interacting with the redeem service
 */
class RedeemClient extends service_client_lib_1.BaseClient {
    constructor({ baseUrl, getHeaders, defaultTimeout, getDefaultQueryParams }) {
        super({
            baseUrl,
            getHeaders,
            defaultTimeout,
            getDefaultQueryParams,
            fieldsToParseMapping: {
                date: ['createdAt', 'updatedAt'],
            },
        });
    }
    /**
     * Fetch all shipping info
     * @param instanceId The ID of the instance
     * @param offset The offset for pagination
     * @returns {GetAllShippingInfoResponse}
     */
    getAllShippingInfo(instanceId, offset, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.get(`/physicals/shipping_info`, {
                    params: { instanceId, offset, limit },
                });
            }
            catch (error) {
                console.error('Failed to get shipping info:', error);
                throw error;
            }
        });
    }
    /**
     * Create a purchase attempt
     * @param instanceId The ID of the instance
     * @param addressInfo The address information
     * @param qualifyingTokens The qualifying tokens
     * @param variationSelection The variation selection
     * @param walletAddress The wallet address making the purchase
     * @returns {CreatePurchaseAttemptResponse}
     */
    createPurchaseAttempt(instanceId, walletAddress, addressInfo, qualifyingTokens, variationSelection, email, phone) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.post(`/physicals/purchase_attempt`, {
                    data: {
                        instanceId,
                        addressInfo,
                        qualifyingTokens,
                        variationSelection,
                        walletAddress,
                        email,
                        phone,
                    },
                });
            }
            catch (error) {
                console.error('Failed to create purchase attempt:', error);
                throw error;
            }
        });
    }
    /* Giveaways Collector Methods */
    createSignup(instanceId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.post(`/giveaways/${instanceId}/signup`);
            }
            catch (error) {
                console.error('Failed to create signup:', error);
                throw error;
            }
        });
    }
    getSignup(instanceId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.get(`/giveaways/${instanceId}/signup`);
            }
            catch (error) {
                console.error('Failed to get signup:', error);
                throw error;
            }
        });
    }
    patchSignup(instanceId, complete, requirements) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.patch(`/giveaways/${instanceId}/signup`, {
                    data: { complete, requirements },
                });
            }
            catch (error) {
                console.error('Failed to patch signup:', error);
                throw error;
            }
        });
    }
    getCurrentSignups(instanceId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.get(`/giveaways/${instanceId}/current_signups`);
            }
            catch (error) {
                console.error('Failed to get current signups:', error);
                throw error;
            }
        });
    }
    /* Giveaways Creator Methods */
    getAllSignupsForInstance(instanceId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.get(`/giveaways/creator/signups?instanceId=${instanceId}`);
            }
            catch (error) {
                console.error('Failed to get all signups for instance:', error);
                throw error;
            }
        });
    }
    patchWinnersForInstance(instanceId, winners) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.patch(`/giveaways/creator/signups/winners?instanceId=${instanceId}`, {
                    data: { winners },
                });
            }
            catch (error) {
                console.error('Failed to patch winners for instance:', error);
                throw error;
            }
        });
    }
}
exports.RedeemClient = RedeemClient;
//# sourceMappingURL=client.js.map